<template>
  <v-container
    fluid
    grid-list-md
    v-if="selectedPlan !== null && selectedPlan !== undefined && planOptions"
  >
    <v-layout row wrap>
      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="work"
        :value="$t('views.employers_view.employer_record')"
      >
        <template slot="actions">
          <div class="d-flex justify-center  flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'employerWizard',
                  params: { planId: selectedPlan.Id },
                })
              "
              v-if="!selectedPlan.Current.IsTesting"
            >
              {{ $t("globals.add_new") }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'searchEmployersForm',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.members.find_and_edit") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="cases"
        :value="$t('views.employers_view.employers_list')"
      >
        <template slot="actions">
          <div class="d-flex justify-center  flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'employersView',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("components.claims_history.view_all") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
        v-if="planOptions.HasBilling && planIdentity && planIdentity.TrackHours"
        :color="$vuetify.theme.themes.light.secondary"
        icon="date_range"
        :value="$t('headers.hourshistory.employer_contribution_term')"
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'contributionsSetup',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("globals.setup") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
        :color="$vuetify.theme.themes.light.secondary"
        icon="publish"
        :value="$t('views.members.data_import')"
      >
        <template slot="actions">
          <div class="d-flex justify-center  flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'wip',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("globals.employers") }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'wip',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("globals.stores") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
    </v-layout>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { planSetter } from "../mixins/planSetter";
export default {
  data() {
    return {
      commissionsCount: 3,
    };
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["messages"]),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("plansMembers", ["planOptions", "planIdentity"]),
  },
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
  },
};
</script>

<style>
.with-margin {
  margin: 10px !important;
}
</style>
